import EcommerceTech from '../containers/ecommerce-tech';

export default EcommerceTech;
